var util = require('../util');
var Aggregator = require('./aggregator');

module.exports = function() {
  // flatten arguments into a single array
  var args = [].reduce.call(arguments, function(a, x) {
    return a.concat(util.array(x));
  }, []);
  // create and return an aggregator
  return new Aggregator()
    .groupby(args)
    .summarize({'*':'values'});
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/datalib/src/aggregate/groupby.js
// module id = 1519
// module chunks = 0